import { FormControl,Radio, RadioGroup,FormControlLabel,MenuItem, Accordion, AccordionDetails, AccordionSummary} from "@mui/material";
import ViewListIcon from "@mui/icons-material/ViewList";
import SearchIcon from "@mui/icons-material/Search";
import IconButton from "@mui/material/IconButton";
// import {DateFormat} from "../../utils";
import React, { useState,useEffect} from "react";
// import { FormEngine } from "../form/FormEngine";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import styled, { css, keyframes } from "styled-components";

  // Styled component for the heading text
  const TextHeadingStyled = styled.div`
    font-weight: ${(props) => props.fontWeight || "semi-bold"};
    text-align: ${(props) => props.alignment || "center"};
    font-style: ${(props) => (props.italic ? "italic" : "normal")};
    color: ${(props) => props.textColor || "#000000"};
    font-family: "Inter", sans-serif;
    font-size: ${(props) => `${props.fontSize}px` || "42px"};
    margin: ${(props) => props.margin || "1rem"};
    white-space: normal;
    overflow:hidden;

    @media (max-width: 639px) {
      /* Styles for screens smaller than 640px (e.g., mobile) */
      font-size: ${(props) =>
        props.fontSize ? `${props.fontSize - 20}px` : "20px"};
      font-weight: bold;
    }

    @media (min-width: 640px) and (max-width: 767px) {
      /* Styles for screens between 640px and 767px (e.g., small tablets) */
      font-size: ${(props) =>
        props.fontSize ? `${props.fontSize - 15}px` : "30px"};
    }
  `;
export const TextHeading = ({ children, alignment, textColor, fontSize,italic,fontWeight,margin }) => {
  return <TextHeadingStyled fontSize={fontSize} textColor={textColor} alignment={alignment} italic={italic} fontWeight={fontWeight} margin={margin}>{children}</TextHeadingStyled>;
};

  // Styled component for the text
const TextMediumStyled = styled.div`
  font-weight: ${(props) => props.fontWeight || "normal"};
  font-style: ${(props) => (props.italic ? 'italic' : 'normal')};
  text-align: ${(props) => props.alignment || "center"}; /* Use prop value for text alignment or default to center */
  color: ${(props) => props.textColor ||"#000000"}; /* Use prop value for text color or default to black */
  font-family: "Inter", sans-serif;
  font-size: ${(props) => `${props.fontSize}px` || "30px"};
  margin: 1rem;
  margin-right:20px;
  white-space: normal;
  max-width:200px;
  overflow:hidden;

  @media (max-width: 639px) {
    /* Styles for screens smaller than 640px (e.g., mobile) */
    font-size: ${(props) => (props.fontSize ? `${props.fontSize - 15}px` : "10px")};
  }

  @media (min-width: 640px) and (max-width: 767px) {
    /* Styles for screens between 640px and 767px (e.g., small tablets) */
    font-size: ${(props) => (props.fontSize ? `${props.fontSize - 10}px` : "20px")};
  }

`;
export const TextMedium = ({ children, alignment, textColor,fontSize,italic,fontWeight }) => {

  return (
    <TextMediumStyled alignment={alignment} textColor={textColor} fontSize={fontSize} italic={italic} fontWeight={fontWeight}>
      {children}
    </TextMediumStyled>
  );
};


// Styled component for the img
  const StyledImageComp = styled.img`
    max-width: 100%; /* Ensure the image scales responsively */
    width: ${(props) =>props.width ||"auto"}; /* Use prop value for width or default to 'auto' */
    height: ${(props) => props.height || "auto"}; /* Use prop value for height or default to 'auto' */
  `;
export const StyledImage = ({width,height,src}) => {
 if(typeof src!=="undefined")
  return (
    <div>
      <StyledImageComp 
        src={src}
        width={width} // Set the desired width using props
        height={height} // Set the desired height using props
      />
    </div>
  );
};



/**
 * Loading display component 
 */
// Define the spin animation
const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

// Styled Spinner component
const StyledSpinner = styled.div`
  display: flex;
  justify-content: center;
  margin: 10px 0;

  svg {
    width: 100px;
    height: 100px;
    animation: ${spin} 2s linear infinite;
  }

  @media (max-width: 768px) {
    svg {
      width: 60px;
      height: 60px;
    }
  }
`;

export const Spinner = () => {
  return (
    <StyledSpinner>
      <svg viewBox="0 0 24 24">
        <path
          d="M24 13.616v-3.232c-1.651-.587-2.694-.752-3.219-2.019v-.001c-.527-1.271.1-2.134.847-3.707l-2.285-2.285c-1.561.742-2.433 1.375-3.707.847h-.001c-1.269-.526-1.435-1.576-2.019-3.219h-3.232c-.582 1.635-.749 2.692-2.019 3.219h-.001c-1.271.528-2.132-.098-3.707-.847l-2.285 2.285c.745 1.568 1.375 2.434.847 3.707-.527 1.271-1.584 1.438-3.219 2.02v3.232c1.632.58 2.692.749 3.219 2.019.53 1.282-.114 2.166-.847 3.707l2.285 2.286c1.562-.743 2.434-1.375 3.707-.847h.001c1.27.526 1.436 1.579 2.019 3.219h3.232c.582-1.636.75-2.69 2.027-3.222h.001c1.262-.524 2.12.101 3.698.851l2.285-2.286c-.744-1.563-1.375-2.433-.848-3.706.527-1.271 1.588-1.44 3.221-2.021zm-12 2.384c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4z"
          className="opacity-100 fill-orange"
        />
      </svg>
    </StyledSpinner>
  );
};


/**
 * Reccuring randon row buttons template(Add row,Delete Row,etc)
 */
export const OutlinedButton = ({onClick,disabled,label,icon}) => {
    return (
        <IconButton sx={{color: "#F47920", borderradius: "50%"}} aria-label={label} onClick={onClick} disabled={disabled} component="label" >
            {icon}
        </IconButton>
    );
};

/**
 * Button template for all Pages it disabled fetaure
 */
const StyledButton = styled.button`
  /* Common styles */
  width: ${(props) => `${props.width}%` || "80%"};
  height: ${(props) => props.height || "fit-content"};
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease;
  padding: 5px;
  border-radius: ${(props) => props.borderradius || "10px"};
  &:hover {
    transform: scale(1.05); /* Increase size by 5% on hover */
  }
  /* Variant styles based on props */
  ${(props) =>
    props.variant === "primary" &&
    css`
      background-color: ${props.bg ? props.bg : "#F47920"};
      opacity: ${props.disabled ? "50%" : "100%"};
      color: white;
    `}

  ${(props) =>
    props.variant === "accept" &&
    css`
      background-color: ${props.bg ? props.bg : "#006400"};
      opacity: ${props.disabled ? "50%" : "100%"};
      color: white;
    `}

   ${(props) =>
    props.variant === "reject" &&
    css`
      background-color: ${props.bg ? props.bg : "#D71515"};
      opacity: ${props.disabled ? "50%" : "100%"};
      color: white;
    `}

    ${(props) =>
    props.variant === "submit" &&
    css`
      background-color: ${props.bg ? props.bg : "#F3934D"};
      opacity: ${props.disabled ? "50%" : "100%"};
      color: white;
    `}

  /* Alignment based on props */
  text-align: ${(props) => props.alignment || "center"};

  /* Font size based on props */
  font-size: ${(props) => `${props.fontSize}px` || "30px"};

  /* Responsive font size */
  @media (max-width: 756px) {
    width: ${(props) => `${props.width}%` || "100%"};
    font-size: ${(props) => `${props.mobilefontsize}px` || "10px"};
  }
`;
export const PrimaryButton = ({ disabled, variant, onClick, children, alignment, fontSize, mobilefontsize,width,height,borderradius }) => {
  return (
    <StyledButton variant={variant} onClick={onClick} disabled={disabled} alignment={alignment} fontSize={fontSize} mobilefontsize={mobilefontsize} width={width} height={height} borderradius={borderradius}>
      {children}
    </StyledButton>
  );
};


const InputContainer = styled.div`
  width: 100%;
  max-width: 850px;
  margin-bottom: 5px;
`;

const StyledInput = styled.input`
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 10px;
  resize: none;
  height: 40px;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #007bff;
  }
`;

export const Input = ({ type, placeholder, value, onChange }) => {
  return (
    <InputContainer>
      <StyledInput
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
    </InputContainer>
  );
};

/**
 * dropdown template for form engine 
 */
const StyledCommonDropdown = styled.div`
  width: 100%;
  max-width: 300px; /* Adjust this value to suit your responsiveness */
`;



/**
 * Radio Button Template used in Job Mapping Page
 */
export const RadioButton = ({handlerFunction,value,options}) => {
    return (
        <FormControl>
            <RadioGroup onChange={handlerFunction} value={value}>
                {options.map((option, index) => (
                    <FormControlLabel key={index} value={option} control={<Radio/>} label={option}/> ))}
            </RadioGroup>
        </FormControl>
    );
};


// Styled component for the modal overlay
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999; /* Ensure the modal is on top of other content */
`;

// Styled component for the modal content
const ModalContent = styled.div`
  background-color: ${(props) =>
    props.backgroundColor || "#ffffff"}; /* Use prop for background color */
  max-width: 80%;
  max-height: 80%;
  overflow: auto;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  border: 5px solid #f47920; /* Add a 2px solid orange border */
`;

export const BasicModal = ({ open, onClose, backgroundColor, children }) => {
  if (!open) return null;

  return (
    <ModalOverlay>
      <ModalContent backgroundColor={backgroundColor}>
        {children}
      </ModalContent>
    </ModalOverlay>
  );
};





/**
 * Search Box component template for All pages sets dropdown list of search result and filters card dispayed upon search input
 */
export const Search = ({ query, label, setQuery, searchData,setSearchData }) => {
  const [dropdown, setDropdown] = useState(false);

   function handleSearch(d) {
     setSearchData([d]);
     setQuery(d.name);
     setDropdown(false)
   }

    useEffect(() => {
      if (query==='') {
        setDropdown(false)
      }
    }, [query]);
  return (
    <div className="relative p-2">
      <div className="flex">
        <IconButton type="submit" aria-label="search">
          <SearchIcon style={{ fill: "orange" }} />
        </IconButton>
        <input type="text" placeholder={label} value={query} onChange={(e) => {setQuery(e.target.value);setDropdown(true)}} className="w-full h-[20px] mx-3 px-4 py-2 rounded-md " />
      </div>
      <ul className={`${dropdown ? "flex flex-col" : "hidden"} absolute w-[200px] mt-2 left-12 bg-white border rounded-md z-50 shadow-md`}>
        {searchData.map((option,index) => (
          <li key={index} onClick={() => handleSearch(option)} className="px-4 py-2 list-none hover:bg-gray-100">
            {option.name}
          </li>
        ))}
      </ul>
    </div>
  );
};


/**
 * Component to flatten Nested Arrays
 */
export const FlattenHandler = (allRows) => {
    let flattenedRows = [];
    const flatten = (rows, index = 0) => {
        return rows.map((x, i) => {
            if (x.description) {
                const {description, ...y} = x;
                flattenedRows.push({ ...y, id: index === 0 ? `${i + 1}` : `${index}.${i + 1}`});
                flatten(x.description, i + 1);
            } else {
                const {response, ...y} = x;
                flattenedRows.push({ ...y,...response, id: index === 0 ? `${i + 1}` : `${index}.${i + 1}`});
            }
        });
    };
    flatten(allRows);
    return flattenedRows;
};


/**
 * Component used to display details on Job Master and Job Status Page
 */
 const Details = ({ job, index,onChange,jobData }) => {
   if (job.fieldType === "role") {
     return (
       <DetailsDisplay
         key={index}
         fieldType={job.fieldType}
         details1={job.headerName}
         className={"w-5/12 flex flex-row gap-4 items-center"}
         details2={
           typeof jobData.roles[index - 4] === "undefined" ||
           jobData.roles[index - 4]["role_values"][0] === null ||
           typeof jobData.roles[index - 4]["role_values"][0] === "undefined"
             ? ""
             : jobData.roles[index - 4]["role_values"][0]["name"]
         }
       />
     );
   } else if (job.fieldType === "dropdown" || job.fieldType === "input") {
     return (
       <>
         <div className={`w-5/12 flex flex-row gap-4 items-center`}>
           <div
             className={`pl-3 w-full md:w-[50%] text-black font-medium font-body text-lg`}
           >
            {job.label}
           </div>
           {/*<div className={"w-full md:w-[50%]"}>*/}
           {/*  <FormEngine*/}
           {/*    fieldType={job.fieldType}*/}
           {/*    type={job.inputType}*/}
           {/*    disabled={false}*/}
           {/*    value={*/}
           {/*      job.inputType === "date"*/}
           {/*        ? jobData[job.id]["$date"].split("T")[0]*/}
           {/*        : jobData[job.id]*/}
           {/*    }*/}
           {/*    required={job.required}*/}
           {/*    onChange={(event) => onChange(event, job.id, job.inputType)}*/}
           {/*    className={""} // Adjust the width as needed*/}
           {/*    name={job.label}*/}
           {/*    options={job.options}*/}
           {/*  />*/}
           {/*</div>*/}
         </div>
       </>
     );
   } else {
     return (
       <DetailsDisplay
         key={index}
         fieldType={job.fieldType}
         details1={job.headerName}
         className={"w-5/12 flex flex-row gap-4 items-center"}
         details2={jobData[job.field]}
         metaData={job}
       />
     );
   }
 };
export const JobDetails = ({metaData,jobData,title,onChange}) => {
    if (typeof metaData !== 'undefined' && typeof jobData !== 'undefined') {
        return (
            <div className="flex flex-col">
                <div className="font-medium text-orange font-body text-2xl mb-3">
                    {title}
                </div>
                <div className="flex flex-row flex-wrap gap-4 justify-between">
                    {metaData.map((job, index) => 
                    (
                       <Details job={job} index={index} key={index} onChange={onChange} jobData={jobData}/>
                    ))}
                </div>
            </div>
        );
    }
};



export const DetailsDisplay = ({fieldType,details1,className,details2,metaData}) => {
  return (
    // <div className={className}>
    //   <div className="pl-3 w-1/2">
    //     <div className="text-black font-medium font-body text-lg">
    //       {details1}
    //     </div>
    //   </div>
    //   <div className="w-1/2">
    //     <div className="break-words font-body text-black text-lg">
    //       {fieldType === "date" && typeof details2 !== 'undefined' && details2!=='-'?  DateFormat(details2["$date"])
    //         : details2 !== undefined ? typeof details2 ==='number' && !Number.isInteger(details2) ?
    //         typeof metaData!=='undefined' && typeof metaData.postFix!== 'undefined'? `${details2.toFixed(2)}%`: details2.toFixed(2):details2 :""
    //       }
    //     </div>
    //   </div>
    // </div>
    <div className={`${className} flex flex-col md:flex-row gap-4 mt-5`}>
      <div className="md:w-1/2">
        <div className="pl-3">
          <div className="text-black font-medium font-bold font-semibold font-body text-lg">
            {details1} {":"}
          </div>
        </div>
      </div>
      <div className="md:w-1/2">
        <div className="pl-3">
          {/*<div className="w-full  font-body text-black text-lg whitespace-normal  md:max-w-md sm:whitespace-normal xs:whitespace-normal">*/}
          {/*  {fieldType === "date" &&*/}
          {/*  typeof details2 !== "undefined" &&*/}
          {/*  details2 !== "-"*/}
          {/*    ? DateFormat(details2["$date"])*/}
          {/*    : details2 !== undefined*/}
          {/*    ? typeof details2 === "number" && !Number.isInteger(details2)*/}
          {/*      ? typeof metaData !== "undefined" &&*/}
          {/*        typeof metaData.postFix !== "undefined"*/}
          {/*        ? `${details2.toFixed(2)}%`*/}
          {/*        : details2.toFixed(2)*/}
          {/*      : details2*/}
          {/*    : ""}*/}
          {/*</div>*/}
        </div>
      </div>
    </div>
  );
};


/**
 * Component used to toggle between list view and card view in Phase Landing Page and Dashboard
 */
export const ViewToggleButton = ({
  setView,
  view,
  xs,
  setXs
}) => {
  const handleViewChange = (nextView) => {
    setView(nextView);
    if(view==="list")
     setXs([12,3])
    else
     setXs([12,12])
  };

  return (
    <div className="p-3">
      <IconButton
        onClick={() => handleViewChange("cards")}
        color={view === "cards" ? "orange" : "default"}
      >
        <ViewModuleIcon />
      </IconButton>
      <IconButton
        onClick={() => handleViewChange("list")}
        color={view === "list" ? "orange" : "default"}
      >
        <ViewListIcon />
      </IconButton>
    </div>
  );
};

